import { atom } from 'jotai';

export const linkSessionsToNewPatientModalOpenAtom = atom<boolean>(false);

export interface LinkSessionsToNewPatientModalOutcome {
  /** `submitted`: Save issued the create-and-link. `dismissed`: Cancel, the X, or a dismiss with no Save. */
  kind: 'submitted' | 'dismissed';
  /** The sessions this modal was creating a patient for. */
  sessionIds: string[];
  /** `Date.now()` at the close; for a Save, after its create-and-link was issued. */
  closedAt: number;
}

/**
 * How the create-patient modal last closed. The modal closes as soon as Save
 * issues its create-and-link, before that mutation settles, so the open atom
 * alone cannot tell a Save from a Cancel. Written on every close by every
 * surface that mounts the modal; an opener reads it only for its own session.
 */
export const linkSessionsToNewPatientModalOutcomeAtom =
  atom<LinkSessionsToNewPatientModalOutcome | null>(null);
